//es5
export default function formFeedback() {
    var $form = $(".js-form-feedback"),
        body = $('body'),
        $button = $form.find('[type="submit"]');

    $form.validate({
        'rules': {
            'FirstName': 'required',
            'OrganizationName': 'required',
            'Description': 'required',
            'email': {
                'required': true,
                'email': true
            },
            'phone': {
                'required': true//,
                //'digits': true
            },
            'file': {
                'extension': 'jpg|jpeg|png|gif|zip|rar|pdf|doc|docx|xls|xlsx'
            },
            'agree': 'required'
        },
        'messages': {
            'FirstName': 'This field is required', // Вы не заполнили поле
            'OrganizationName': 'This field is required', // Вы не заполнили поле
            'Description': 'This field is required', // Вы не заполнили поле
            'email': {
                'required': 'This field is required', // Вы не заполнили поле
                'email': 'This field is incorrectly filled' // Некорректно заполнено поле
            },
            'phone': {
                'required': 'This field is required'//, // Вы не заполнили поле
                //'digits': 'This field is incorrectly filled' // Некорректно заполнено поле
            },
            'file': {
                'extension': 'Wrong format' // Неверный формат
            },
            'agree': 'This field is required' // Это поле обязательно
        },
        'errorElement': 'em',
        'errorClass': '_novalid',
        'validClass': "_valid",
        'highlight': function(element, errorClass, validClass) {
            var $el = $(element);
            $el.closest('.js-field-item:not(._hidden)').addClass(errorClass).removeClass(validClass);
        },
        'unhighlight': function(element, errorClass, validClass) {
            var $el = $(element);
            $el.closest('.js-field-item').removeClass(errorClass).addClass(validClass);
        }
    });

    $form.find('[name="phone"]').inputmask("Regex", {
        regex: "^[0-9 +]+$",
        placeholder: ''
    });
    // $form.find('[name="phone"]').inputmask({
    //     mask: '+9 (999) 999-99-99',
    //     showMaskOnHover: false
    // });

    $form.on('submit', function(e){
        var isvalidate = $(this).valid();

        // Сохраняем поле с clientID из гугл-аналитики
        $form.find('.js-value-cid').val(window.clientIdGA);

        // разбиваем FirstName по первому пробелу и 2ю часть в LastName
        var fullName = $form.find('input[name="FirstName"]').val().split(' ');

        // if (!$form.data('crm')) {
        //     if (fullName.length > 1) {
        //         $form.find('input[name="LastName"]').val(fullName.slice(1).join(' '));
        //         $form.find('input[name="FirstName"]').val(fullName.slice(0,1));
        //     } else {
        //         $form.find('input[name="LastName"]').val(fullName);
        //         $form.find('input[name="FirstName"]').val(fullName);
        //     }
        // }

        // if (isvalidate && $form.data('action-crm') && $form.data('crm')) {
        //     $form.data('crm', '');
        //     $button.attr('disabled','');
        //     $form.attr('action', $form.data('action-crm'));
        //     //$(document).trigger('ga:contact_form:send');
        //     $.cookie('form_to_crm', '1', {path: '/'});
        // } else
        if(isvalidate) {
            $button.attr('disabled','');

            var url = $form.attr('action'),
                formData = new FormData($form[0]),
                type = $form.attr('method');

            var request = $.ajax({
                url: url,
                dataType: 'json',
                data: formData,
                type: type,
                async: false,
                cache: false,
                contentType: false,
                processData: false
            });

            request.done(function(response, status) {
                if (status == 'success') {
                    // закоменчено т.к. после отправки формы ее надо послать в еще и в CRM
                    $form.add($form.parent()).addClass('_success');
                    setTimeout(function() {
                        $form.add($form.parent()).removeClass('_success');
                        $form.clearForm();
                        $('.js-file').parent().find('span').text('Прикрепить файл');
                        $form.find('.js-field-item').removeClass('_valid');
                        $button.removeAttr('disabled');
                    }, 3000);
                    $(document).trigger('ga:contact_form:send');

                    // повторная отправка в CRM
                    // $form.find('[name="file"]').val('');
                    // $form.data('crm', true);
                    // $form.submit();
                } else {
                    $button.removeAttr('disabled');
                }
            });

            request.fail(function( jqXHR, textStatus ) {
                console.log( "Request failed: " + textStatus );
                request.abort();
                $button.removeAttr('disabled');
            });

            return false;
        }
    });

    $form.find('input').on('input change', function () {
        $(this).valid();

        if ($(this).parents('.js-field-item').is('._valid')){

            if ($(this).parents('.js-field-item').is('.js-field-item-type')){
                $(this).parents('form').find('.js-field-item').removeClass('_hidden');
            } else {
                $(this).parents('.js-field-item').next().removeClass('_hidden');
            }
        }

        // если крепится файл, обрезаем название пути по длине
        if ( $(this).is('.js-file')) {
            var value = $(this).val();

            value = value.substring(value.lastIndexOf('\\')+1, value.length);
            if (value.length > 15) value = '..'+value.slice(-15);

            $(this).parent().find('span').text(value ? value : 'Прикрепить файл');
        }
    });

    $form.find('.js-file').closest('.js-field-item').on('click', '.js-file-close', function (e) {
        e.preventDefault();
        $(e.delegateTarget).find('span').text('Прикрепить файл');
        $(e.delegateTarget).find('input').val('');
        $(e.delegateTarget).removeClass('_novalid');
    });

    $form.find('.js-file').on('focus',function () {
        $(this).closest('.js-field-item').addClass('_focus');
    }).on('blur',function () {
        $(this).closest('.js-field-item').removeClass('_focus');
    });

    $form.find('input:not([type="checkbox"])').each(function () {
        if ($(this).val()){
            if ($(this).parents('.js-field-item').is('.js-field-item-type')){
                $(this).parents('form').find('.js-field-item').removeClass('_hidden');
            } else {
                $(this).parents('.js-field-item').removeClass('_hidden').next().removeClass('_hidden');
            }
        }
        $(this).on('focus', function () {
            if ($(this).is('[type="submit"]')) return;
            $(document).trigger('ga:contact_form:focus', $(this).data('label'));
        });
    });

    function formTimer ($form) {
        var time = 0,
            $input = $form.find('.js-form-time');

        if ($input.length) {
            setInterval(function() {
                time++;
                $input.attr('value',time);
            }, 1000);
        }
    }

    formTimer($form);

    // попап|селект в форме
    function customSelectInit() {
        var select = $('.js-select');

        if (!select.length) return;

        // открываем окно селекта
        select.on('focus', function () {
            var parent = $(this).parents('.js-field-item');

            body.addClass('js-popup-opened');
            toggleSelectDrop(parent);
        });

        // выбор элемента списка
        $form.find('.js-input-popup ul li').on('click', function () {
            var val = $(this).text(),
                parent = $(this).parents('.js-field-item');

            toggleSelectItem(parent, $(this), val);
            toggleSelectDrop(parent);

            select.trigger('input');
        });

        // закрываем попап при клике по экрану
        body.on('click', function () {
            if (!$(this).is('.js-input-popup') && !$('.js-popup-opened').length) {
                $('.js-input-popup').fadeOut('100');
            }
        });

        // запрещаем ввод и выделение
        $form.find('.js-input-popup').on('selectstart', () => { return false; });
        $form.find('.js-select').on('keydown', () => { return false; });
    }

    function toggleSelectDrop(context) {
        var select = context.find('.js-input-popup');
        select.stop(false, true).fadeToggle('500', () =>  body.removeClass('js-popup-opened') );
    }

    function toggleSelectItem(context, $this, value) {
        context.find('.js-select').val(value);
        context.find('.js-input-popup ul li').removeClass('_selected');
        $this.addClass('_selected');
    }
    customSelectInit();
};



// WEBPACK FOOTER //
// ./_src/js/form-feedback.js